import React, { useContext } from "react";
import { RequiredMark, RequiredMarkContext } from "components";
import { Form, Col, Row } from "react-bootstrap";
import styles from "components/fields/inputs/fields.module.scss";
import clsx from "clsx";

const TaxId = ({
	input,
	as,
	label,
	helperLabel,
	placeholder,
	type,
	meta: { touched, error, warning, asyncValidating },
	disabled,
	disableInput,
	commonName,
	maxHeight = false,
	role = false,
	customError,
	tabIndex,
	loader,
	loading,
	smLabel = 6,
	smSelect = 6,
	wrapperClassName,
	hideRequiredMark, //works only with RequiredMarkContext
	additionalField = null,
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;

	const checkSpanRequired = showRequiredMark && <RequiredMark />;

	const disabledClass = disabled ? styles.disabled : "";
	const labelBlock = label && (
		<Col sm={smLabel}>
			<Form.Label className={styles.wrappLabel}>
				<span>
					{label}
					{checkSpanRequired}
				</span>
			</Form.Label>
			{helperLabel && (
				<span className={styles.helperLabel}>{helperLabel}</span>
			)}
		</Col>
	);

	const showError = touched && !disabled;
	const errorMessage = error && <p className={styles.spanError}>{error}</p>;
	const customErrorMessage = customError && (
		<p className={styles.spanError}>{customError}</p>
	);
	const warningMessage = warning && (
		<p className={styles.spanWarn}>{warning}</p>
	);

	const hasError =
		(showError && touched && (errorMessage || customErrorMessage)) ||
		warningMessage;
	const validationClass =
		showError &&
		touched &&
		(((error || customError) && styles.error) ||
			(warning && styles.warning));

	let checkRole = role ? styles.merhantDesc : null;
	let checkHeight = maxHeight ? styles.maxHeight : null;

	const inputField = (
		<>
			<Form.Control
				{...input}
				as={as}
				tabIndex={tabIndex}
				common-name={commonName}
				placeholder={placeholder}
				disabled={disabled || disableInput}
				type={type}
				isInvalid={touched && errorMessage}
				className={clsx(
					styles.field,
					checkRole,
					validationClass,
					checkHeight,
				)}
			/>
			{hasError}
		</>
	);

	return (
		<span className={clsx(disabledClass, styles.formGroup)}>
			<Form.Group
				as={Row}
				className={clsx(styles.inputWrapper, wrapperClassName)}
			>
				{labelBlock}
				<Col sm={smSelect}>
					<div style={{ marginBottom: "20px" }}>{inputField}</div>
					{additionalField}
				</Col>
				{(loading || asyncValidating) && loader ? loader() : null}
			</Form.Group>
		</span>
	);
};

export default TaxId;
